const ucfirstFilter = function (input) {
    return (typeof input === 'string') ? input.ucfirst() : input;
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ucfirstFilter;
}
